import { get, post } from 'actions/api';

export const getSubjects = (type) =>
  get('FETCH_FEEDBACK_SUBJECTS', 'api', `/feedback/v2/subjects?type=${type}`, {});

export const create = (data) => post('CREATE_FEEDBACK', data, 'api', '/feedback/v3/entries', {});
